// 记录一些配置项
window.__editorConfig__ = {
  replaceKeywordOptions: {}
};

const setData = newVal => {
  window.__editorConfig__ = {
    ...window.__editorConfig__,
    ...newVal
  };
};

const getData = () => {
  return window.__editorConfig__;
};

export { setData, getData };
